import { ArrowRight } from "lucide-react";
import { Reveal, Label } from "./Reveal";

// Quiet discovery section for the five in-depth sleep pages — parent-centered
// descriptions, editorial list rows, no keyword-stuffed blocks. This is the
// homepage's always-visible crawlable path to the SEO pages (alongside the
// in-guide links and the footer group).
const RESOURCES = [
  {
    href: "/pediatric-sleep-consultant",
    title: "Pediatric Sleep Consulting",
    desc: "The whole picture — what a consultant does, who it helps, and how we work together.",
  },
  {
    href: "/sleep-guides",
    title: "Sleep Guides",
    desc: "Real answers for the 2 a.m. searches — by stage and by struggle.",
  },
  {
    href: "/newborn-sleep-consultant",
    title: "Newborn Sleep",
    desc: "The first three months — what's actually normal, and the gentle early foundations.",
  },
  {
    href: "/baby-sleep-consultant",
    title: "Baby & Infant Sleep",
    desc: "Night waking, short naps and the crib transfer, roughly 4–17 months.",
  },
  {
    href: "/toddler-sleep-consultant",
    title: "Toddler Sleep",
    desc: "Bedtime negotiations, hallway footsteps and very early mornings.",
  },
  {
    href: "/virtual-sleep-consultant",
    title: "Virtual Sleep Support",
    desc: "The same one-on-one conversation, wherever you live.",
  },
  {
    href: "/denver-sleep-consultant",
    title: "Denver Sleep Support",
    desc: "Working together in the Denver area — and when in-person may be possible.",
  },
  {
    href: "/denver-in-home-sleep-consultant",
    title: "In-Home Sleep Support",
    desc: "For Denver-area families who'd like Andrea in the room.",
  },
  {
    href: "/colorado-pediatric-sleep-consultant",
    title: "Colorado Sleep Support",
    desc: "In-home around Denver, virtual across the whole state.",
  },
];

export const Resources = () => (
  <section id="sleep-support" data-testid="resources-section" className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-20 py-24 lg:py-32 scroll-mt-24">
    <Reveal>
      <Label>Keep reading</Label>
      <h2 className="mt-6 font-serif font-light text-4xl sm:text-5xl leading-[1.06] tracking-tight text-ink max-w-3xl">
        Sleep support for <span className="italic text-clay">every stage.</span>
      </h2>
      <p className="mt-5 max-w-xl text-base sm:text-lg font-normal leading-relaxed text-smoke">
        Deeper reading for whatever your nights look like right now — same
        conversation, just more of it.
      </p>
    </Reveal>
    <div className="mt-14 border-t border-ink/10">
      {RESOURCES.map((r, i) => (
        <Reveal key={r.href} delay={0.05 * i}>
          <a
            data-testid={`resource-link-${r.href.slice(1)}`}
            href={r.href}
            className="group grid lg:grid-cols-12 gap-2 lg:gap-6 py-7 lg:py-8 border-b border-ink/10 items-baseline"
          >
            <span className="lg:col-span-4 font-serif font-light text-2xl sm:text-3xl text-ink group-hover:text-claydark transition-colors duration-300">
              {r.title}
            </span>
            <span className="lg:col-span-7 text-sm sm:text-base font-normal text-smoke leading-relaxed">
              {r.desc}
            </span>
            <span className="hidden lg:block lg:col-span-1 lg:text-right text-claydark">
              <ArrowRight size={16} className="inline transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" />
            </span>
          </a>
        </Reveal>
      ))}
    </div>
  </section>
);
